import type { XYChartAreaSeriesProps } from '../types/xy-chart-props.js';

/**
 * Area series slot component.
 * @public
 */
export const AreaSeries = (props: XYChartAreaSeriesProps) => null;

AreaSeries['displayName'] = 'XYChart.AreaSeries';
